import { useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:8001/api/v1";

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [cargando, setCargando] = useState(false);

  async function handleLogin() {
    if (!username || !password) return;
    setCargando(true);
    setError(null);
    try {
      const res = await axios.post(
  API + "/auth/login",
  { username, password },
  { withCredentials: true }
);
onLogin(res.data.usuario, res.data.requiere_cambio_password, res.data.access_token);
    } catch (e) {
      if (e.response?.status === 429) {
        setError("Demasiados intentos fallidos. Espera 1 minuto antes de intentar de nuevo.");
      } else {
        setError("Credenciales incorrectas. Intenta de nuevo.");
      }
    } finally {
      setCargando(false);
    }
  }

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="bg-gray-800 rounded-2xl shadow-2xl p-8 w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/logo.png" alt="ZLinkINT" className="h-12 w-12 object-cover rounded-lg mx-auto mb-3" />
          <h1 className="text-3xl font-bold text-white">🇲🇽 OSINT México</h1>
          <p className="text-gray-400 mt-2">Plataforma de Inteligencia</p>
          <p className="text-gray-500 text-sm mt-1">Acceso restringido — personal autorizado</p>
        </div>

        <div className="space-y-4">
          <div>
            <label className="text-gray-400 text-sm mb-1 block">Usuario</label>
            <input
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              onKeyDown={e => e.key === "Enter" && handleLogin()}
              placeholder="Ingresa tu usuario"
              className="w-full bg-gray-700 text-white border border-gray-600 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="text-gray-400 text-sm mb-1 block">Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              onKeyDown={e => e.key === "Enter" && handleLogin()}
              placeholder="Ingresa tu contraseña"
              className="w-full bg-gray-700 text-white border border-gray-600 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {error && (
            <div className="bg-red-900 border border-red-700 text-red-300 rounded-lg p-3 text-sm">
              {error}
            </div>
          )}

          <button
            onClick={handleLogin}
            disabled={cargando}
            className="w-full bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white font-semibold py-3 rounded-lg transition-colors"
          >
            {cargando ? "Verificando..." : "Iniciar Sesión"}
          </button>
        </div>

        <p className="text-gray-600 text-xs text-center mt-6">
          Sistema protegido — todas las sesiones son auditadas
        </p>
      </div>
    </div>
  );
}